var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { GeminiSummaryMetricLine, GeminiSummarySlashPair } from '@web/components/Apps/Gemini/geminiSummaryCards';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { PeriodDiff } from '@web/components/layout/PeriodDiff/PeriodDiff';
import { SummaryCardLabel, SummaryCardShell } from '@web/components/layout/SummaryCards/SummaryCards';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared';
import { formatDuration } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var summaryMetricDiffClassName = 'shrink-0 text-xs font-semibold';
var formatTeamDiff = function (teamAverage) { var _a; return (_a = teamAverage === null || teamAverage === void 0 ? void 0 : teamAverage.diffString) !== null && _a !== void 0 ? _a : ''; };
var ShareSlashPair = function (_a) {
    var pair = _a.pair;
    return (_jsxs("div", __assign({ className: "mt-1 flex flex-wrap items-baseline gap-x-1 gap-y-1" }, { children: [_jsxs("span", __assign({ className: "inline-flex min-w-0 items-baseline gap-0.5" }, { children: [_jsxs("span", __assign({ className: "shrink-0 text-xl font-semibold leading-none tracking-tight tabular-nums text-slate-900" }, { children: [pair.left.share, "%"] })), _jsx(PeriodDiff, { diff: pair.left.previous, className: summaryMetricDiffClassName, prefixSpace: false })] })), _jsx("span", __assign({ className: "shrink-0 text-slate-300" }, { children: "/" })), _jsxs("span", __assign({ className: "inline-flex min-w-0 items-baseline gap-0.5" }, { children: [_jsxs("span", __assign({ className: "shrink-0 text-xl font-semibold leading-none tracking-tight tabular-nums text-slate-900" }, { children: [pair.right.share, "%"] })), _jsx(PeriodDiff, { diff: pair.right.previous, className: summaryMetricDiffClassName, prefixSpace: false })] }))] })));
};
var formatSharePair = function (pair) {
    return "".concat(pair.left.share, "% / ").concat(pair.right.share, "%");
};
var toCountMetricLineProps = function (metric, showTeamDiff) { return ({
    value: String(metric.count),
    prevPeriodDiff: metric.previous,
    teamAvgDiff: showTeamDiff ? metric.teamAverage : undefined
}); };
var toSecondsMetricLineProps = function (metric, showTeamDiff) { return ({
    value: formatDuration(metric.seconds, 'seconds'),
    prevPeriodDiff: metric.previous,
    teamAvgDiff: showTeamDiff ? metric.teamAverage : undefined
}); };
var buildCsvRows = function (data, t, showManHours, showTeamDiff) {
    var _a, _b, _c, _d, _e;
    var teamDiffKey = showTeamDiff
        ? t('app.apps.meeting.summary.export.teamDiff')
        : null;
    var withTeamDiff = function (row, teamAverage) {
        var _a;
        return teamDiffKey
            ? __assign(__assign({}, row), (_a = {}, _a[teamDiffKey] = typeof teamAverage === 'string'
                ? teamAverage
                : formatTeamDiff(teamAverage), _a)) : row;
    };
    return [
        withTeamDiff((_a = {},
            _a[t('app.apps.meeting.summary.export.metric')] = t('app.apps.meeting.summary.meetingsAttended'),
            _a[t('app.apps.meeting.summary.export.value')] = data.meetingsAttended.count,
            _a[t('app.apps.meeting.summary.export.diff')] = data.meetingsAttended.previous.diffString,
            _a), data.meetingsAttended.teamAverage),
        withTeamDiff((_b = {},
            _b[t('app.apps.meeting.summary.export.metric')] = t(showManHours
                ? 'app.apps.meeting.summary.totalDurationManHours'
                : 'app.apps.meeting.summary.totalDuration'),
            _b[t('app.apps.meeting.summary.export.value')] = showManHours
                ? "".concat(formatDuration(data.totalDuration.seconds, 'seconds'), " / ").concat(formatDuration(data.manHours.seconds, 'seconds'))
                : formatDuration(data.totalDuration.seconds, 'seconds'),
            _b[t('app.apps.meeting.summary.export.diff')] = showManHours
                ? "".concat(data.totalDuration.previous.diffString, " / ").concat(data.manHours.previous.diffString)
                : data.totalDuration.previous.diffString,
            _b), showManHours
            ? "".concat(formatTeamDiff(data.totalDuration.teamAverage), " / ").concat(formatTeamDiff(data.manHours.teamAverage))
            : data.totalDuration.teamAverage),
        (_c = {},
            _c[t('app.apps.meeting.summary.export.metric')] = t('app.apps.meeting.summary.oneToOneVsGroup'),
            _c[t('app.apps.meeting.summary.export.value')] = formatSharePair(data.oneToOneVsGroup),
            _c[t('app.apps.meeting.summary.export.diff')] = "".concat(data.oneToOneVsGroup.left.previous.diffString, " / ").concat(data.oneToOneVsGroup.right.previous.diffString),
            _c),
        (_d = {},
            _d[t('app.apps.meeting.summary.export.metric')] = t('app.apps.meeting.summary.internalVsExternal'),
            _d[t('app.apps.meeting.summary.export.value')] = formatSharePair(data.internalVsExternal),
            _d[t('app.apps.meeting.summary.export.diff')] = "".concat(data.internalVsExternal.left.previous.diffString, " / ").concat(data.internalVsExternal.right.previous.diffString),
            _d),
        (_e = {},
            _e[t('app.apps.meeting.summary.export.metric')] = t('app.apps.meeting.summary.recurringVsAdhoc'),
            _e[t('app.apps.meeting.summary.export.value')] = formatSharePair(data.recurringVsAdhoc),
            _e[t('app.apps.meeting.summary.export.diff')] = "".concat(data.recurringVsAdhoc.left.previous.diffString, " / ").concat(data.recurringVsAdhoc.right.previous.diffString),
            _e)
    ];
};
function MeetSummary() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var _b = trpc.meetSummary.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showManHours = Boolean(data.manHours);
    var showTeamDiff = Boolean(user);
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.apps.meeting.summary.title'), description: "widgetTitleDescriptions.apps.meetSummary", insightType: InsightTypeEnum.meetSummary, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.apps.meeting.summary.title'), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, buildCsvRows(data, t, showManHours, showTeamDiff)];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5" }, { children: [_jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.meeting.summary.meetingsAttended') }), _jsx(GeminiSummaryMetricLine, __assign({}, toCountMetricLineProps(data.meetingsAttended, showTeamDiff)))] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t(showManHours
                                    ? 'app.apps.meeting.summary.totalDurationManHours'
                                    : 'app.apps.meeting.summary.totalDuration') }), showManHours ? (_jsx(GeminiSummarySlashPair, { left: toSecondsMetricLineProps(data.totalDuration, showTeamDiff), right: toSecondsMetricLineProps(data.manHours, showTeamDiff) })) : (_jsx(GeminiSummaryMetricLine, __assign({}, toSecondsMetricLineProps(data.totalDuration, showTeamDiff))))] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.meeting.summary.oneToOneVsGroup') }), _jsx(ShareSlashPair, { pair: data.oneToOneVsGroup })] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.meeting.summary.internalVsExternal') }), _jsx(ShareSlashPair, { pair: data.internalVsExternal })] }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, { children: t('app.apps.meeting.summary.recurringVsAdhoc') }), _jsx(ShareSlashPair, { pair: data.recurringVsAdhoc })] })] }))] }));
}
export default MeetSummary;
